/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var SkipForward = createReactComponent("skip-forward", "SkipForward", [["path", { "d": "M19.5 3v18m-4.726-8.22-8.65 6.92a1 1 0 0 1-1.624-.78V5.08a1 1 0 0 1 1.625-.78l8.649 6.92a1 1 0 0 1 0 1.56", "key": "svg-0" }]]);

export { SkipForward as default };
//# sourceMappingURL=SkipForward.js.map
